export default __webpack_public_path__ + "static/media/4.11ee870f.png";